<div class="card rounded-md overflow-hidden !p-0 !mt-4 !mb-4">
    <p-table
        #dt
        [value]="products" 
        dataKey="id" 
        [lazy]="true"
        [paginator]="true"
        [totalRecords]="resultsLength"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="{first} - {last} sur {totalRecords}"
        [rows]="pageSize"
        [rowsPerPageOptions]="pageSizeOptions"
        [columns]="selectedColumns" 
        [loading]="isLoadingResults"
        [scrollable]="true" 
        scrollHeight="538px"
        [expandedRowKeys]="expandedRows" 
        (onLazyLoad)="onLazyLoad($event)"
        (onStateRestore)="onStateRestore($event)"
        stateKey="_ssk"
        stateStorage="local"
        [defaultSortOrder]="-1"
        >
        <!-- If filter is open or not 538px/634px -->
        <ng-template #caption>
            <div class="flex  justify-between gap-2">
                <p-button label="Tout réduire" icon="pi pi-chevron-up" text (click)="collapseAll()" [disabled]="(expandedRows | json) == '{}'" />
                <p-multiselect display="chip" [options]="cols" [(ngModel)]="selectedColumns" (onChange)="onSelectedColumnChange($event)" optionLabel="header" [filter]="false" [showToggleAll]="false" selectedItemsLabel="{0} colonnes sélectionnées" [style]="{ 'min-width': '300px' }" placeholder="Colonnes supplémentaires" />
            </div>
        </ng-template>
        <ng-template #header let-columns>
            <tr>
                <th pFrozenColumn class="w-14"></th>
                <th pSortableColumn="id" class="w-34 whitespace-nowrap !text-center">Id / Image <p-sortIcon field="id" /></th>
                <th pSortableColumn="marque_id" class="whitespace-nowrap">Marque <p-sortIcon field="marque_id" /></th>
                <th pSortableColumn="reference" class="whitespace-nowrap">Réference <p-sortIcon field="reference" /></th>
                @for (col of columns; track $index) {
                    <th [pSortableColumn]="col.field" class="whitespace-nowrap">{{ col.header }} <p-sortIcon [field]="col.field" /></th>
                }
                <th pFrozenColumn alignFrozen="right" class="whitespace-nowrap">Quantité / Prix minimum</th>
            </tr>
        </ng-template>
        <ng-template #body let-product let-columns="columns" let-expanded="expanded">
            <tr>
                <td pFrozenColumn>
                    <p-button type="button" pRipple [pRowToggler]="product" [text]="true" severity="secondary" [rounded]="true" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'" />
                </td>
                <td class="!px-0">
                    <a [routerLink]="['/products', product.id]" class="flex flex-col justify-center items-center">
                        <img [src]="apiUrl + product.photo_couverture" alt="{{product.reference}}" width="80" height="80" class="h-20 w-20 shadow-lg object-cover rounded-md" />
                        <p-tag severity="contrast" [value]="'#' + product.id_old" class="-mt-3 relative z-0 !text-base" />
                        @if (product.etat_ebay > 0) {
                            <p-tag [severity]="utilityService.getEbaySeverity(product.etat_ebay)" [value]="utilityService.getEbayLabel(product.etat_ebay)" class="mt-2" />
                        }
                    </a>
                </td>
                <td>{{ product.marque?.nom }}</td>
                <td>{{ product.reference }}</td>
                @for (col of columns; track $index) {
                    <td>{{ col.field.endsWith('_at') ? (product[col.field] | date) : product[col.field]?.nom }}</td>
                }
                <td pFrozenColumn alignFrozen="right">
                    <div class="flex flex-col gap-2">
                        @for (stock of getMinStock(product); track $index) {
                            <div class="flex flex-row gap-2 items-center">
                                <p-badge [value]="`x${stock['etat_quantite']}`" size="large" [severity]="getBadgeSeverity(stock['etat_quantite'])" />
                                <p-tag [severity]="utilityService.getStateSeverity(stock.etat)" [value]="utilityService.getStateLabel(stock.etat)" />
                                <span>{{ stock.prix | currency : 'EUR' }}</span>
                            </div>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>
        <ng-template #expandedrow let-product>
            <tr>
                <td [attr.colspan]="selectedColumns.length + 5" class="p-0">
                    <div class="p-4">
                        <h5>Stocks pour {{ product.marque?.nom + ' ' + product.reference }}</h5>
                        <p-table [value]="product.stocks" dataKey="id">
                            <ng-template #header>
                                <tr>
                                    <th pSortableColumn="etat">
                                        <div class="flex items-center gap-2">
                                            État
                                            <p-sortIcon field="etat" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="note">
                                        <div class="flex items-center gap-2">
                                            Note
                                            <p-sortIcon field="note" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="prix">
                                        <div class="flex items-center gap-2">
                                            Prix
                                            <p-sortIcon field="prix" />
                                        </div>
                                    </th>
                                    <th pSortableColumn="quantite">
                                        <div class="flex items-center gap-2">
                                            Quantité
                                            <p-sortIcon field="quantite" />
                                        </div>
                                    </th>
                                    <th>
                                        <div class="flex items-center gap-2">
                                            Rangement
                                        </div>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template #body let-stock>
                                <tr>
                                    <td><p-tag [severity]="utilityService.getStateSeverity(stock.etat)" [value]="utilityService.getStateLabel(stock.etat)" /></td>
                                    <td><p-rating [ngModel]="stock.note" [readonly]="true" /></td>
                                    <td>{{ stock.prix | currency : 'EUR' }}</td>
                                    <td>{{ stock.quantite }}</td>
                                    <td><span class="inline-block px-2 py-1 rounded-sm mr-3" [class]="utilityService.getSectorClassColor(stock.secteur?.nom)">{{ stock.secteur?.nom }}</span> <code>{{ stock.etagere }} {{ stock.rayon }}</code></td>
                                </tr>
                            </ng-template>
                            <ng-template #emptymessage>
                                <tr>
                                    <td colspan="6">Il n'y a pas de stock pour ce produit.</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>